<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!--      <img src="../../public/img/user.png" class="img-avatar" alt="user-image">-->
      <img src="../../src/assets/charkhoune.png" class="img-avatar" alt="user-image">
    </template>
    \
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <!--<strong>حسابداری</strong>-->
      <!--</b-dropdown-header>-->
      <!--<b-dropdown-item to="/banks">-->
        <!--<i class="fa fa-bell-o"/> بانک ها-->
        <!--&lt;!&ndash;<b-badge variant="info">{{ itemsCount }}</b-badge>&ndash;&gt;-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-envelope-o"/> پیام ها-->
        <!--<b-badge variant="success">{{ itemsCount }}</b-badge>-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-tasks"/> کارها-->
        <!--<b-badge variant="danger">{{ itemsCount }}</b-badge>-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-comments"/> توضیحات-->
        <!--<b-badge variant="warning">{{ itemsCount }}</b-badge>-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-header tag="div" class="text-center">-->
        <strong>تنظیمات</strong>
      </b-dropdown-header>
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-user"/> صفحه کاربری-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-wrench"/> تنظیمات-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-usd"/> پرداخت ها-->
        <!--<b-badge variant="secondary">{{ itemsCount }}</b-badge>-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-item>-->
        <!--<i class="fa fa-file"/> پروژه ها-->
        <!--<b-badge variant="primary">{{ itemsCount }}</b-badge>-->
      <!--</b-dropdown-item>-->
      <!--<b-dropdown-divider/>-->
      <b-dropdown-item @click="changeRole">
        <i class="fa fa-shield"/> تغییر کاربر
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        <i class="fa fa-power-off"/> خروج
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
  import {HeaderDropdown as AppHeaderDropdown} from "@coreui/vue";
  import axios from "axios";
  import _nav from "../_nav.js";

  export default {
    name: "DefaultHeaderDropdownAccnt",
    components: {
      AppHeaderDropdown
    },
    data: () => {
      return {itemsCount: 42};
    },
    methods: {
      logout() {
        localStorage.removeItem("accesses");
        localStorage.removeItem("company");
        localStorage.removeItem("post");
        localStorage.removeItem("username");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("postId");
        localStorage.removeItem("navItemsType");
        axios.defaults.headers.common["Authorization"] = "";
        _nav.items = [];
        this.$router.push({name: "ورود"});
      },
      changeRole() {
        this.$router.push({name: "تغییر کاربر"});
      }
    }
  };
</script>
